/**
 * @description https://github.com/TheSharpieOne/angular-input-match
 */
;(function () {
  angular.module('contrast.form').directive('matchInput', function () {
    return {
      require: 'ngModel',
      restrict: 'A',
      scope: {
        matchInput: '='
      },
      link: function (scope, elem, attrs, ctrl) {
        scope.$watch(
          function () {
            // eslint-disable-next-line angular/no-private-call
            var modelValue = ctrl.$modelValue || ctrl.$$invalidModelValue
            return (
              (ctrl.$pristine &&
                angular.isUndefined(modelValue) &&
                (angular.isUndefined(scope.matchInput) ||
                  scope.matchInput === '')) ||
              (angular.isUndefined(modelValue) &&
                (angular.isUndefined(scope.matchInput) ||
                  scope.matchInput === '')) ||
              scope.matchInput === modelValue
            )
          },
          function (currentValue) {
            ctrl.$setValidity('match', currentValue)
          }
        )
      }
    }
  })
})()
